import { useSdkBuildInfo } from './useSdkBuildInfo'
import { hostingVersionsApi } from '../hostingVersionsApi'

export const useHostingVersionsCatalogueQuery = (manualSkip = false) => {
  const appKind = useSdkBuildInfo()?.appKind

  return hostingVersionsApi.endpoints.getHostingVersionsCatalogue.useQuery(
    { forAppKind: appKind! },
    { skip: !appKind || manualSkip }
  )
}
